import totalScore from '@/api/total-score-grading-range'
import assessment from '@/api/score-assessment-main'
import definition from '@/api/grading-definition'
import mainProgram from '@/api/main-program'
import grade from '@/api/grade'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  score_version_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SCORE_VERSION_ID(state, data) {
    state.score_version_id = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        filter: {
          score_version_id: context.state.score_version_id
        }
      },
      attributes
    )

    return totalScore.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return totalScore.store(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await totalScore.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  update(context, { id, data }) {
    return totalScore.update(id, data)
  },
  getMainProgram(context) {
    return mainProgram.get({
      params: {
        fields: {
          academic_program_mains: 'acp_id,acp_name_foreign'
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getProgramStructure(context, acp_id) {
    return assessment.get({
      params: {
        filter: {
          program_stucture_by_acp: acp_id
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getDefinition(context, data) {
    return definition.get({
      params: {
        fields: {
          score_grading_definitions: 'grade_definition_id,definition_name_en,grade'
        },
        filter: {
          acp_id: data.acp_id,
          acps_id: data.acps_id,
          definition_type: 'Grading'
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getScoreVersions() {
    return grade.getScoringVersions({ params: { page: -1 } })
  }
}
